(function () {
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  if (motion.matches || saveData || !('IntersectionObserver' in window)) return;

  var targets = [
    '.muse-benefits__intro', '.muse-benefits__item',
    '.muse-clients__heading', '.muse-clients__brand', '.muse-clients__entry',
    '.muse-products .section-heading', '.muse-products .product-card',
    '.muse-turnkey__photo', '.muse-turnkey__content',
    '.muse-scents__heading', '.muse-scent',
    '.muse-contact__intro', '.muse-contact__form'
  ].join(',');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

  function init(scope) {
    var nodes = scope.querySelectorAll(targets);
    nodes.forEach(function (node) {
      if (node.hasAttribute('data-muse-reveal')) return;
      // Keep everything initially on screen visible, including anchor targets.
      if (node.getBoundingClientRect().top <= window.innerHeight * .88) return;
      node.style.setProperty('--muse-delay', ((Array.prototype.indexOf.call(node.parentElement.children, node) % 3) * 85) + 'ms');
      node.setAttribute('data-muse-reveal', '');
      observer.observe(node);
    });
    document.documentElement.classList.add('muse-motion-enabled');
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  motion.addEventListener('change', function () {
    if (!motion.matches) return;
    document.documentElement.classList.remove('muse-motion-enabled');
    observer.disconnect();
  });
})();
